;(() => {
  let timeout

  const triggerRefresh = (delay = 1500) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart::refresh-items'))
    }, delay)
  }

  document.addEventListener('cart::add', () => triggerRefresh(1500))

  document.addEventListener(
    'click',
    (e) => {
      const removeBtn = e.target.closest('.cart-item__remove')
      if (removeBtn) {
        document.dispatchEvent(
          new CustomEvent('abra::item-removed-from-cart', {
            detail: {
              timestamp: new Date().toISOString(),
            },
          })
        )
        triggerRefresh(1500)
        return
      }

      const path = e.composedPath()
      const isQuantityButton = path.some(
        (el) =>
          el.tagName === 'BUTTON' && (el.name === 'plus' || el.name === 'minus')
      )
      if (isQuantityButton) {
        triggerRefresh(2500)
      }
    },
    true
  )
})()
